<template>
    <v-container fluid v-if="bill">
        <v-row cols="12">
            <v-col xs="12" sm="12" md="12" lg="12" xl="6">
                <v-card>
                    <card-header
                        :title="$tc('resources.bill.name', 1)"
                        :showBackButton="false"
                    />
                    <v-row cols="12">
                        <v-col xs="12" sm="12" md="4" lg="4">
                            <v-list-item>
                                <v-list-item-content class="text-center">
                                    <v-list-item-subtitle
                                        class="overline black--text"
                                    >
                                        {{
                                            $t(
                                                'resources.bill.attributes.dueAt',
                                            )
                                        }}
                                    </v-list-item-subtitle>
                                    <v-list-item-title
                                        class="display-1 font-weight-light text--darken-2"
                                    >
                                        {{ bill.formattedDueAt }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-col>

                        <v-col xs="12" sm="12" md="4" lg="4">
                            <v-list-item>
                                <v-list-item-content class="text-center">
                                    <v-list-item-subtitle
                                        class="overline black--text"
                                    >
                                        {{
                                            $t(
                                                'resources.bill.attributes.totalValue',
                                            )
                                        }}
                                    </v-list-item-subtitle>
                                    <v-list-item-title
                                        class="display-1 black--text"
                                    >
                                        {{ bill.formattedTotalValue }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-col>

                        <v-col xs="12" sm="12" md="4" lg="4">
                            <v-list-item>
                                <v-list-item-content class="text-center">
                                    <v-list-item-subtitle
                                        class="overline black--text"
                                    >
                                        Situação
                                    </v-list-item-subtitle>
                                    <v-list-item-title
                                        class="display-1 black--text"
                                    >
                                        <div>
                                            <v-chip
                                                class="mt-4"
                                                color="success"
                                                text-color="white"
                                                v-if="bill.status"
                                            >
                                                <v-avatar left>
                                                    <v-icon>
                                                        mdi-checkbox-marked-circle
                                                    </v-icon>
                                                </v-avatar>
                                                {{
                                                    $t(
                                                        'resources.bill.getters.status.paid',
                                                    )
                                                }}
                                            </v-chip>
                                            <v-chip
                                                color="blue-grey lighten-2"
                                                text-color="white"
                                                v-else
                                                class="mt-4"
                                            >
                                                <v-avatar left>
                                                    <v-icon>
                                                        mdi-clock
                                                    </v-icon>
                                                </v-avatar>
                                                {{
                                                    $t(
                                                        'resources.bill.getters.status.pending',
                                                    )
                                                }}
                                            </v-chip>
                                        </div>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-divider></v-divider>
                        </v-col>
                    </v-row>

                    <!-- VALORES -->
                    <v-row>
                        <v-col>
                            <v-card-title class="subtitle-2">
                                <v-icon left>
                                    mdi-format-list-bulleted
                                </v-icon>
                                Valores
                            </v-card-title>
                            <v-card-text>
                                <v-row cols="12">
                                    <v-col md="4" lg="4">
                                        <v-currency-field
                                            :label="
                                                $t(
                                                    'resources.bill.attributes.value',
                                                )
                                            "
                                            v-bind="$t('money-config')"
                                            v-model="bill.value"
                                            disabled
                                        ></v-currency-field>
                                    </v-col>

                                    <v-col md="4" lg="4">
                                        <v-currency-field
                                            :label="
                                                $t(
                                                    'resources.bill.attributes.discount',
                                                )
                                            "
                                            v-bind="$t('money-config')"
                                            v-model="bill.discount"
                                            disabled
                                        />
                                    </v-col>

                                    <v-col md="4" lg="4">
                                        <v-currency-field
                                            :label="
                                                $t(
                                                    'resources.bill.attributes.interest',
                                                )
                                            "
                                            v-bind="$t('money-config')"
                                            v-model="bill.interest"
                                            disabled
                                        />
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-col>
                    </v-row>

                    <!-- ACTIONS -->
                    <v-card-actions>
                        <v-spacer />
                        <resource-actions
                            :model="bill"
                            pageContext="show"
                            @click="$refs.actionHandler[$event.type](bill)"
                        />
                    </v-card-actions>
                </v-card>
            </v-col>

            <!-- RESUME -->
            <v-col xs="12" sm="12" md="12" lg="12" xl="6">
                <BillResume :bill="bill" />
            </v-col>

            <!-- NEGOTIATION -->
            <v-col xs="12" sm="12" md="12" lg="12" xl="6" v-if="hasNegotiation">
                <BillNegotiationCard :billNegotiation="bill.billNegotiation" />
            </v-col>
        </v-row>
        <BillActions ref="actionHandler" @modelChanged="reloadPage()" />
    </v-container>
</template>

<script>
import Bill from '@/models/Bill'
import BillNegotiation from '@/models/BillNegotiation'
import BillActions from '@/components/actions/bill/BillActions'
import BillNegotiationCard from '@/shared/components/BillNegotiationCard'
import BillResume from '@/shared/components/BillResume'
import Period from '@/models/Period'
import CardHeader from '@/components/utils/CardHeader'
import ResourceActions from '@/shared/components/ResourceActions'

export default {
    props: ['id'],

    components: {
        CardHeader,
        BillNegotiationCard,
        BillActions,
        BillResume,
        ResourceActions,
    },

    data: () => {
        return {
            bill: null,
            expanded: [],
            loading: false,
            calculating: false,
            transmitting: false,
            canceling: false,
        }
    },

    watch: {
        id() {
            this.getBill()
        },
    },

    methods: {
        async getBill() {
            let item = await this.model.find(this.id)
            this.bill = item
        },

        async save() {
            this.loading = true

            let clone = this.bill.clone()

            let res = null

            try {
                res = await clone.save().catch(() => {})
            } finally {
                this.loading = false
            }

            if (!res) return

            this.$bus.$emit('notify', 'success', 'Fatura salva com sucesso')

            this.$router.push({ name: 'bills' })
        },

        reloadPage() {
            window.location.reload()
        },
    },

    computed: {
        model() {
            return new Bill()
        },

        period() {
            return new Period()
        },

        hasNegotiation() {
            return this.bill.billNegotiation instanceof BillNegotiation
        },
    },

    created() {
        this.getBill()
    },
}
</script>

<style></style>
